
export function defineIfArchitectureIsStrict(cloudCode) {
    const strictList = process.env.NEXT_PUBLIC_PROVIDERS_STRICT_INSTANCE_ARCHITECTURE;
    return strictList.split(',').includes(cloudCode);
}